import { useEffect, useState } from 'react'
import TextNavTitle from '../../../components/TextNavTitle'
import NavTitle from '../../../components/nav-title'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { FaCircleCheck, FaPrint } from 'react-icons/fa6'
import { FaSync } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import NavRoleOrg from '../../../components/nav-role-org'
import { fnDateEn } from '../../../helper/fnDateEn'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import styled from 'styled-components'
import {
  listTempPayrollAPI,
  printTempPayrollAPI,
  syncTempPayrollAPI,
  syncTempPayrollStatusAPI
} from '../../../services/income/payroll'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import Error_false from '../../../components/error/error-false'
import Swal from 'sweetalert2'
import SwalCustom from '../../../alert/swal-custom'
import SwalCustomSuccess from '../../../alert/swal-success'
import { useSearchParams } from 'react-router-dom'
import { io } from 'socket.io-client'
import { API_URL, TOKEN } from '../../../Constants'
import ButtonExportExcel from './ButtonExportExcel'

export default function IncomePayrollPage() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const totalLimits = 20
  const [totalRows, setTotalRow] = useState(0)
  const [page, setPage] = useState(1)
  const [dataTable, setDataTable] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [selectMonth, setSelectMonth] = useState(new Date())
  let [searchParams, setSearchParams] = useSearchParams()
  let _month = searchParams.get('paymentPeriodDate')
  const [isStatus, setIsStatus] = useState()

  const [isPrinted, setIsPrinted] = useState(false)

  const socket = io(API_URL.replace('hrms/', '') + 'payroll-temp-sync', {
    auth: {
      token: localStorage.getItem(TOKEN)
    }
  })

  useEffect(() => {
    socket.on('Webhook', (data) => {
      setIsStatus(data.result?.queueStatusId)

      setSyncStatus({
        ...fnMapStatus(data.result)
      })
    })
    return () => {
      socket.off('Webhook')
    }
  }, [])

  let _paymentPeriodDate = _month
    ? new Date(fnDateEn(_month, 'YYYYMM').format('YYYY-MM-DD'))
    : new Date()

  const body = {
    ...bodyFilter,
    page: 1,
    orgId,
    paymentPeriodDate: fnDateEn(_paymentPeriodDate).format('YYYYMM')
  }

  useEffect(() => {
    if (isStatus === 3) {
      fnGetData(body)
    }
  }, [isStatus])

  useEffect(() => {
    setSelectMonth(_paymentPeriodDate)

    if (orgId) {
      fnGetData(body)
    }
  }, [orgId])

  const fnGetData = async (body) => {
    setSearchParams(body)
    setIsLoading(true)
    setBodyFilter(body)
    setPage(body.page)
    fnGetStatusSync()
    const resp = await listTempPayrollAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setIsPrinted(resp.isPrinted)
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnGetStatusSync = async () => {
    setSyncStatus({
      isLoading: true,
      icon: <FaSync className="me-2" />,
      status: 'Sync'
    })
    const resp = await syncTempPayrollStatusAPI()
    if (!resp) return
    if (resp.status) {
      setSyncStatus({
        isLoading: false,
        ...fnMapStatus(resp.result)
      })
    } else {
      setSyncStatus({
        isLoading: false,
        ...syncStatus
      })
    }
  }

  const fnMapStatus = (d) => {
    switch (d.queueStatusId) {
      case 2:
        return {
          isLoading: true,
          isDisabled: true,
          icon: <FaSync className="me-2 animation-spin" />,
          status: d.queueStatus
        }
      case 3:
        return {
          isLoading: false,
          isDisabled: true,
          icon: <FaCircleCheck className="me-2 " />,
          status: d.queueStatus
        }
      default:
        return {
          isLoading: false,
          isDisabled: false,
          icon: <FaSync className="me-2 " />,
          status: d.queueStatus
        }
    }
  }

  const { control, handleSubmit } = useForm({})

  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search
    }
    fnGetData(body)
  }
  const [syncStatus, setSyncStatus] = useState({
    isLoading: false,
    icon: <FaSync className="me-2" />,
    status: 'Sync'
  })
  const fnSyncData = async () => {
    try {
      setSyncStatus({
        isLoading: true,
        ...syncStatus
      })
      const body = {
        orgId,
        paymentPeriodDate: fnDateEn(selectMonth).format('YYYYMM')
      }
      const resp = await syncTempPayrollAPI(body)
      if (!resp) return
      if (resp.status) {
        fnGetData(bodyFilter)
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Swal.showValidationMessage(`
          Request failed: ${error}
        `)
    }
  }

  const fnPrintData = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, print it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const body = {
          orgId,
          paymentPeriodDate: fnDateEn(selectMonth).format('YYYYMM')
        }
        const resp = await printTempPayrollAPI(body)
        if (!resp) return
        if (resp.status) {
          SwalCustomSuccess().then(() => {
            fnGetData(bodyFilter)
          })
        } else {
          Error_false(resp)
        }
      }
    })
  }
  return (
    <div>
      <NavTitle>
        <TextNavTitle>Payroll</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3">
            <Row>
              <Col md={2} className="">
                <label className="small">
                  Total: {totalRows.toLocaleString()}
                </label>
              </Col>

              <Col md={10} className="text-end">
                <BoxFilter className="justify-content-end">
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          disabled={isLoading}
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <div className="from-date">
                    <CustomDatePicker
                      value={selectMonth}
                      showYearDropdown
                      isClearable={false}
                      placeholderText="Periods"
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                      onChange={(d) => {
                        if (d) {
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            paymentPeriodDate: fnDateEn(d).format('YYYYMM')
                          }
                          fnGetData(body)
                          setSelectMonth(d)
                        } else {
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            paymentPeriodDate: fnDateEn().format('YYYYMM')
                          }
                          fnGetData(body)
                          setSelectMonth(new Date())
                        }
                      }}
                    />
                  </div>
                  <div>
                    <Button
                      className="px-4 text-primary btn-sync"
                      variant="light"
                      disabled={syncStatus.isDisabled || isPrinted}
                      onClick={() => {
                        fnSyncData()
                      }}
                    >
                      {syncStatus?.icon}
                      {syncStatus?.status}
                    </Button>
                  </div>
                  <div>
                    <ButtonExportExcel
                      disabled={isPrinted}
                      bodyFilter={bodyFilter}
                    />
                    <Button
                      disabled={isPrinted}
                      className="px-4 btn btn-primary btn-print ms-2"
                      onClick={() => {
                        fnPrintData()
                      }}
                    >
                      <FaPrint className="me-2" />
                      Print
                    </Button>
                  </div>
                </BoxFilter>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th className="fw-normal ">#</th>

                <th className="fw-normal ">Periods</th>
                <th className="fw-normal ">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Payment Type</th>

                <th className="fw-normal ">Type</th>
                <th
                  className="fw-normal text-end"
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Income
                </th>
                <th
                  className="fw-normal text-end"
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Deduction
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Unit Type
                </th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {isLoading ? (
                <TableSkeletonBody colSpan={9} rowSpan={7} />
              ) : isPrinted ? (
                <tr className="font-small-2 align-middle">
                  <td colSpan={9} className="text-center text-primary">
                    <FaCircleCheck className="me-2" /> Printed
                  </td>
                </tr>
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td className="align-top">
                      {' '}
                      {page * totalLimits - totalLimits + i + 1}
                    </td>
                    <td className="align-top">
                      {fnDateEn(d.paymentPeriodDate).format('MM/YYYY')}
                    </td>
                    <td className="align-top">{d.code}</td>
                    <td className="align-top">
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td className="align-top">
                      {/* {d.paymentName} */}

                      {d.details.map((item, _) => (
                        <p key={`${_}-${i}`}>
                          {_ + 1}. {item.paymentName}
                        </p>
                      ))}
                    </td>
                    <td className="align-top">
                      {d.details.map((item, _) => (
                        <p key={`${_}-${i}`}>{item.paymentListTypeName}</p>
                      ))}
                    </td>
                    <td className="align-top">
                      {/* {d.paymentAmounts?.toLocaleString()} */}
                      {d.details.map((item, _) =>
                        item.paymentListTypeId === 1 ? (
                          <p key={`${_}-${i}`} className={`text-end`}>
                            {item.paymentAmounts?.toLocaleString()}
                          </p>
                        ) : (
                          <p className={`opacity-0 `}>-</p>
                        )
                      )}
                    </td>
                    <td className="align-top">
                      {d.details.map((item, _) =>
                        item.paymentListTypeId === 2 ? (
                          <p key={`${_}-${i}`} className={`text-end`}>
                            {item.paymentAmounts?.toLocaleString()}
                          </p>
                        ) : (
                          <p className={`opacity-0 `}>-</p>
                        )
                      )}
                    </td>
                    <td className="align-top">
                      {d.details.map((item, _) => (
                        <p key={`${_}-${i}`}>{item.paymentDataTypeName}</p>
                      ))}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="font-small-2 align-middle">
                  <td colSpan={9} className="text-center">
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)

              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 350px;
  }

  .btn-new {
    flex: 0 0 150px;
  }

  .from-date {
    flex: 0 0 150px;
  }
  .btn-sync {
    flex: 0 0 120px;
  }
  .btn-print {
    flex: 0 0 120px;
  }
  .animation-spin {
    animation: 1s linear infinite spinner-border;
  }
`
